import {ErrorField} from "@components/fields/error-field/error-field"

type InputTypes = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
const events = ["blur", "input", "change"]

export class Field {
  field: HTMLElement
  input: InputTypes | null
  error: ErrorField

  constructor(field: HTMLElement) {
    this.field = field
    this.input = field.querySelector("input, select, textarea")
    this.error = new ErrorField(this.field.querySelector(".f-error") ?? null)

    this.init()
  }

  private init() {
    this.field.addEventListener("validate", () => {
      this.validate()
    })
  }

  setDisabled(disabled: boolean) {
    this.input?.toggleAttribute("disabled", disabled)
    this.field.classList.toggle("--disabled", disabled)
  }

  setActive(active: boolean) {
    this.field.classList.toggle("--active", active)
  }

  setInvalid(message: string, isValid: boolean) {
    if (!this.input) return

    this.error.toggle(!isValid)
    this.error.setTitle(message)
    this.input.setAttribute("aria-invalid", String(!isValid))
  }

  validate() {
    if (!this.input) return

    const isValid = this.input.checkValidity()
    const message = this.getValidationMessage()

    this.field.classList.toggle("--invalid", !isValid)

    this.setInvalid(message, isValid)
  }

  handleInputEvents = () => {
    this.field.classList.add("--validating")

    events.forEach((event) => {
      this.input?.addEventListener(event, () => {
        this.validate()
      })
    })
  }

  getValidationMessage = () => {
    if (!this.input) return ""

    const {validity, dataset} = this.input
    let message = this.input.validationMessage

    // This could be expanded for any validity type and change message.
    // Since I doubt this will be ever used, I will just leave it only for patternMismatch.
    // But feel free to expand this.
    if (validity.patternMismatch && dataset.validityPatternMismatch) {
      message = dataset.validityPatternMismatch
    }

    if (validity.valueMissing && dataset.validityValueMissing) {
      message = dataset.validityValueMissing
    }

    return message
  }
}
